import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-clinical-survey',
  templateUrl: './clinical-survey.component.html',
  styleUrls: ['./clinical-survey.component.css']
})
export class ClinicalSurveyComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
